import React, { useEffect, useState } from 'react';
import VetsmithContainer from './VetsmithContainer';
import axios from 'axios';
import { Spin, message } from 'antd';
import { ApiConstant, PageConstant } from '../../constants';
import { pushLog2DV2LogServer } from '../../services/logging';
import { redirector } from '../../services/redirector';

function JobVetsmith (props) {
  const [jobVetsmithId, setJobVetsmithId] = useState(null);

  const loadData = async () => {
    try {
      const logBody = {
        jobId: props.match.params.jobId
      };

      pushLog2DV2LogServer.info('JOB_VETSMITH_PAGE', `JOB_VETSMITH_PAGE_VISIT`, {}, logBody);
      const jobVetsmith = await axios.post(`${ApiConstant.BASE_URL}v1/vetsmith/get-job-vetsmith/${props.match.params.jobId}`);
      setJobVetsmithId(jobVetsmith?.data?.data?.vetsmithFlowId);

      logBody.jobVetsmithResponse = jobVetsmith;
      pushLog2DV2LogServer.info('JOB_VETSMITH_PAGE', `JOB_VETSMITH_LOAD_SUCCESS`, {}, logBody);
  
    } catch (error) {
      if(error && error?.response && error?.response?.status === 400) {
        message.error('Hiring for this position is currently paused. Please check other open jobs on the jobs page.', 10);
        redirector.to(PageConstant.APPLIED_JOBS_PAGE);
        return;
      }

      const errorMessage = error && error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Something went wrong. Please try again later';
      message.error(errorMessage);
      const logBody = {
        jobId: props.match.params.jobId,
        error
      };
      pushLog2DV2LogServer.info('JOB_VETSMITH_PAGE', `JOB_VETSMITH_LOAD_FAILURE`, {}, logBody);
      redirector.to(PageConstant.APPLIED_JOBS_PAGE);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // Props to forward to vetsmith component
  const vetsmithProps = {
    flowId: jobVetsmithId,
    vetsmithJobId: props.match.params.jobId
  };
  return (
    jobVetsmithId ? <VetsmithContainer {...props} vetsmithProps={vetsmithProps} /> : <Spin className='center-loader' spinning={true} />
  );
};

export default JobVetsmith;
